import React from "react";

interface IProps {
  width?: number;
  height?: number;
  fillColor?: string;
}

const CustomizableGameIcon: React.FC<IProps> = ({
  width = 14,
  height = 16,
  fillColor = "white",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Setting">
      <path
        id="Setting_2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8776 9.13676C13.1349 9.27344 13.3334 9.48924 13.473 9.70505C13.745 10.151 13.723 10.6978 13.4583 11.1797L12.9437 12.0429C12.6717 12.5033 12.1645 12.7911 11.6425 12.7911C11.3852 12.7911 11.0985 12.7191 10.8633 12.5753C10.6721 12.453 10.4516 12.4098 10.2163 12.4098C9.48854 12.4098 8.87836 13.0069 8.85631 13.719C8.85631 14.5463 8.17997 15.1937 7.33455 15.1937H6.33475C5.48197 15.1937 4.80564 14.5463 4.80564 13.719C4.79093 13.0069 4.18076 12.4098 3.45296 12.4098C3.21036 12.4098 2.98982 12.453 2.80603 12.5753C2.57078 12.7191 2.27672 12.7911 2.02677 12.7911C1.49747 12.7911 0.990213 12.5033 0.718208 12.0429L0.210955 11.1797C-0.0610502 10.7121 -0.0757531 10.151 0.196252 9.70505C0.313876 9.48924 0.534421 9.27344 0.784371 9.13676C0.990213 9.03605 1.12254 8.8706 1.24752 8.67637C1.61509 8.05773 1.39454 7.24486 0.769668 6.87799C0.0418707 6.46796 -0.193377 5.55438 0.225658 4.84222L0.718208 3.99338C1.14459 3.28122 2.05618 3.02944 2.79133 3.44667C3.43091 3.79196 4.26163 3.56177 4.63655 2.95032C4.75418 2.7489 4.82034 2.53309 4.80564 2.31728C4.79093 2.03674 4.8718 1.77057 5.01148 1.55477C5.28348 1.10877 5.77603 0.821028 6.31269 0.806641H7.34925C7.89326 0.806641 8.38581 1.10877 8.65782 1.55477C8.79014 1.77057 8.87836 2.03674 8.85631 2.31728C8.84161 2.53309 8.90777 2.7489 9.02539 2.95032C9.40032 3.56177 10.231 3.79196 10.878 3.44667C11.6058 3.02944 12.5247 3.28122 12.9437 3.99338L13.4363 4.84222C13.8627 5.55438 13.6274 6.46796 12.8923 6.87799C12.2674 7.24486 12.0469 8.05773 12.4218 8.67637C12.5394 8.8706 12.6717 9.03605 12.8776 9.13676ZM4.75411 8.00732C4.75411 9.13671 5.68775 10.0359 6.84193 10.0359C7.99611 10.0359 8.9077 9.13671 8.9077 8.00732C8.9077 6.87793 7.99611 5.97155 6.84193 5.97155C5.68775 5.97155 4.75411 6.87793 4.75411 8.00732Z"
        fill={fillColor}
      />
    </g>
  </svg>
);

export default CustomizableGameIcon;
